import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/providers/auth/auth.service';

@Component({
  selector: 'app-signature',
  standalone: true,
  imports: [],
  templateUrl: './signature.component.html',
  styleUrl: './signature.component.scss',
})
export default class SignatureComponent implements OnInit {
  constructor(
    public authService: AuthenticationService<any>,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Si l'utilisateur est connecté, on redirige
    if (this.authService.currentUserValue) {
      this.router.navigate(['/commercial/opportunity']);
    }
    // Sinon, on reste sur la page et le message s'affiche
  }

  goToLogin(): void {
    this.router.navigate(['/account/login']);
  }
}
